import React from 'react';
import styles from './Preview.module.scss';
import SVG from 'react-inlinesvg';

//Translations
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';

//Interfaces
import { MatchForecast } from '../interfaces/tip/MatchForecast';

//Components
import { getSportIcon } from '../utils/icons/getSportIcon';
import { TipResultDot } from '../../Shops/Tip/components/TipBox/ResultDot/TipResultDot';
import { fullDateFormatter } from '../utils/fullDateFormatter';

interface PreviewMatchForecastInfoProps {
  forecast: MatchForecast;
}

export const PreviewMatchForecastInfo: React.FC<PreviewMatchForecastInfoProps> =
  ({ forecast }) => {
    const { t } = useTranslation();

    return (
      <div className={styles.match} key={forecast.home_player + forecast.tip}>
        <div className={styles.topRow}>
          <span className={styles.text}>
            {forecast.home_player}
            {forecast.away_player.length ? ` - ${forecast.away_player}` : ''}
          </span>

          <span className={styles.date}>
            {fullDateFormatter(forecast.start_date)}
          </span>
        </div>

        <div className={styles.sportsContainer}>
          <SVG src={getSportIcon(forecast.sport.code)} />

          {tr(t, forecast.sport.name || forecast.sport.code)}

          {' - '}

          {forecast.competition_name}
        </div>

        <div className={styles.pickInfo}>
          <div className={styles.line} />

          <div className={styles.pickMsgAndResult}>
            <TipResultDot result={'NOT_STARTED'} />

            <div className={styles.pickAndMarket}>
              <div className={styles.pick}>
                <span className={styles.msg}>{forecast.tip}</span>

                <span className={styles.pickIcon}>
                  {tr(t, 'tip').toUpperCase()}
                </span>
              </div>

              <span className={styles.market}>
                {t(`markets:bet_markets_${forecast.market.code}`).replace(
                  'bet_markets_',
                  '',
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
